export const SET_VIEW = 'SET_VIEW';

export const ASSIGN_PETITIONS_REQUEST = 'ASSIGN_PETITIONS_REQUEST';
export const ASSIGN_PETITIONS_SUCCESS = 'ASSIGN_PETITIONS_SUCCESS';
export const ASSIGN_PETITIONS_FAILED = 'ASSIGN_PETITIONS_FAILED';
